const routes = [
  {
    path: '/document/:documentId',
    name: 'api',
    component: () => import('@/views/Profile/DocumentDetail.vue'),
    meta: {
      auth: true
    }
  }
]
export default routes
